import { _ as _objectSpread2, r as resetFocus } from './transitions-eb14ab1a.esm.js';
import { motion, spaceForBorderWidth } from '@hover/blueprint-theme';
import { transitions } from 'polished';
import '@hover/utilities';
import 'ramda/src/values';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/map';
import 'ramda/src/mergeDeepWith';
import '@chakra-ui/theme-tools';
import { s as sizes$1 } from './sizes-8d1fe38d.esm.js';
import '@hover/tokens-typography';
import _pick from 'ramda/src/pick';

var spaceForBorder = /*#__PURE__*/spaceForBorderWidth(400);

// These are all required to hack around a hard-coded padding value in `Select`

var paddingVerticalMedium = /*#__PURE__*/spaceForBorder(300);
var paddingVerticalSmall = /*#__PURE__*/spaceForBorder(100);
var paddingVerticalTiny = /*#__PURE__*/spaceForBorder(50);
var paddingHorizontalMedium = 400;
var paddingHorizontalSmall = 300;
var paddingHorizontalTiny = 200;

// NOTE: we need to use an explicit height value here, which is why we're
// referencing the size tokens directly (e.g: `sizeTokens['400']` → `48px`)
// instead of using a theme preset (e.g: '400') because Chakra uses the raw
// value to compute the size of left/right input add-ons and elements
var sizes = {
  "default": {
    field: {
      height: sizes$1['400'],
      paddingY: paddingVerticalMedium,
      paddingX: paddingHorizontalMedium,
      textStyle: 'body500'
    }
  },
  small: {
    field: {
      height: sizes$1['300'],
      paddingY: paddingVerticalSmall,
      paddingX: paddingHorizontalSmall,
      textStyle: 'body500'
    }
  },
  tiny: {
    field: {
      height: sizes$1['200'],
      paddingY: paddingVerticalTiny,
      paddingX: paddingHorizontalTiny,
      borderRadius: '200',
      textStyle: 'body400'
    }
  }
};
var field = function field(_ref) {
  var isInvalid = _ref.isInvalid;
  var focus = {
    border: isInvalid ? 'invalidFocus' : 'focus',
    shadow: isInvalid ? 'haloDanger' : 'haloPrimary'
  };
  return _objectSpread2(_objectSpread2({
    appearance: 'none',
    background: 'neutral.0',
    border: isInvalid ? 'invalid' : 'idle',
    boxSizing: 'border-box',
    color: isInvalid ? 'danger.700' : 'neutral.text',
    borderRadius: 300,
    fontFamily: 'body',
    fontWeight: 'body',
    minWidth: 0,
    outline: 0,
    position: 'relative'
  }, transitions(['border', 'box-shadow', 'color', 'background'], motion.easings[250])), {}, {
    shadow: 'invisibleNeutral',
    width: '100%',
    _placeholder: {
      color: 'neutral.500',
      opacity: 1
    },
    _focus: focus,
    _focusWithin: focus,
    _disabled: {
      background: 'neutral.100',
      border: 'disabled',
      color: 'neutral.600',
      cursor: 'not-allowed'
    }
  }, sizes["default"].field);
};

var variants = {
  "default": function _default(_ref) {
    var colorScheme = _ref.colorScheme,
      colors = _ref.theme.colors;
    var hover = _pick(['backgroundColor'], colors.softColorFor(colorScheme));
    return {
      command: {
        color: 'neutral.600',
        fontFamily: 'body',
        fontWeight: 500,
        opacity: 1,
        textStyle: 'body400'
      },
      divider: {
        borderWidth: '0 0 1px',
        boxSizing: 'border-box',
        borderStyle: 'none none solid',
        color: 'neutral.200',
        height: 0,
        marginX: 300,
        marginY: 200,
        opacity: 1,
        overflow: 'visible'
      },
      groupTitle: {
        color: 'neutral.600',
        fontFamily: 'body',
        fontWeight: 'bodySemiBold',
        margin: 0,
        paddingX: 300,
        paddingY: 200,
        textTransform: 'uppercase',
        textStyle: 'body300'
      },
      item: _objectSpread2({
        background: 'transparent',
        border: 0,
        color: 'neutral.text',
        cursor: 'pointer',
        fontFamily: 'body',
        paddingX: 300,
        paddingY: 100,
        textStyle: 'body500',
        _disabled: {
          cursor: 'default'
        },
        _hover: hover
      }, resetFocus(hover)),
      list: {
        background: 'neutral.0',
        border: 'none',
        borderRadius: 300,
        minWidth: '14rem',
        // TODO: `700` token?
        paddingX: 0,
        paddingY: 100,
        shadow: 'distance300',
        zIndex: 1
      }
    };
  }
};

export { paddingVerticalSmall as a, paddingHorizontalTiny as b, paddingVerticalTiny as c, paddingHorizontalMedium as d, paddingVerticalMedium as e, field as f, paddingHorizontalSmall as p, sizes as s, variants as v };
